<template>
  <div>
    <component style="display: none" :is="show_document"></component>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol>
                <strong>{{ $t('factorLists') }}</strong>
              </CCol>


            </CRow>
            <CRow>
              <CCol col="3">
                <date-picker

                    :label="$t('components.startDate')"
                    v-model="start_date"></date-picker>
              </CCol>
              <CCol col="3">
                <date-picker
                    :label="$t('components.endDate')"
                    v-model="end_date"></date-picker>

              </CCol>
              <CCol sm="3">
                <treeselect
                    v-model="refer_person"
                    :cacheOptions="false"
                    :async="true"
                    :load-options="load_persons"
                    :placeholder="$t('components.searchUser')"
                    :normalizer="normalizer_persons"
                />

              </CCol>
              <CCol col="3">
                <CButton @click="get_all_data()" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>
            </CRow>

          </CCardHeader>
          <CCardBody>

            <CDataTableFixed
                :items="items_sell"
                :fields="fields"
                column-filter
                @row-clicked="table_row_clicked"
                height="350px"
                :items-per-page="20"
                hover
                sorter
                :sorter-value="{column:'recId',asc:false}"
                pagination
            >
              <template #row="{item}">

                <td style="text-align: center">
                  <p >{{ item.row_id + 1 }}</p>

                </td>

              </template>
              <template #createdAt="{item}">

                <td>
                  <p >{{ get_date_time(item.createdAt) }}</p>

                </td>

              </template>

              <template #warehouse="{item}">
                <td>
                  <p >{{ item.placeName }}</p>

                </td>

              </template>
              <template #price="{item}">

                <td>
                  <p >{{ get_currency(item.totalPrice) }}</p>

                </td>


              </template>
              <template #cashReceive="{item}">

                <td>
                  <p >{{ get_currency(item.cashReceive) }}</p>

                </td>


              </template>
              <template #partyName="{item}">

                <td>
                  <p >{{ item.partyName }}</p>

                </td>

              </template>
              <template #toziKonande="{item}">

                <td>
                  <p v-if="item.toziKonande!=null" >{{ item.toziKonande }}</p>

                </td>

              </template>
              <template #user="{item}">

                <td>
                  <p >{{ item.createdBy }}</p>

                </td>

              </template>


              <template #statusId="{item}">
                <td>
                  <p v-if="item.statusId==0">موقت</p>
                  <p v-if="item.statusId==1">نهایی</p>

                </td>
              </template>
              <template #caption>
                <tr class="total-table">
                  <td></td>

                  <td>{{$t('totalCirculation')}}</td>
                  <td></td>

                  <td>
                    {{get_currency(calculate_items(items_sell,'totalPrice'))}}
                  </td>
                  <td :class="calculate_items(items_sell,'totalPrice').toFixed(0)!=calculate_items(items_sell,'cashReceive').toFixed(0)?'text-warning':'text-success'">
                    {{get_currency(calculate_items(items_sell,'cashReceive'))}}
                  </td>
                  <td></td>

                  <td></td>
                  <td></td>
                </tr>
              </template>
            </CDataTableFixed>
          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'

var simulateAsync=null
const simulateAsyncOperation = fn => {
  if(simulateAsync!=null){
    clearTimeout(simulateAsync)
  }
  simulateAsync =  setTimeout(fn, 1000)
}
var items_data = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
    'test-dynamic': () => import('../documents/PrintDocument'),

  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      show_document: 'test-dynamic',
      printed_doc_id: 0,
      name: '',


      start_date: '',
      end_date: '',
      submit_refer: 0,
      refer_person: null,
      selected_template: 0,
      id_checkbox_items: [],
      item_sell_array: [],
      items_buy: [],
      items_buy_return:[],
      items_sell: [],
      items_sell_return: [],
      items_first: [],
      items_first_return: [],
      table_clicks_timer: '',
      table_clicks: 0,
      table_clicks_index: 0,

      fields: [
        {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
        {key: 'createdAt', label: this.$t('tables.date'), _style: 'width:15%'},
        {key: 'masterCode', label: this.$t('tables.number'), _style: 'width:2%'},
        // {key: 'انبار', _style: 'width:10%'},
        {key: 'price', label: this.$t('tables.price'), _style: 'width:10%'},
        {key: 'cashReceive', label: this.$t('components.receive'), _style: 'width:10%'},
        {key: 'partyName', label: this.$t('tables.customer'), _style: 'width:20%'},
        {key: 'user', label: this.$t('tables.user'), _style: 'width:15%'},
        {key: 'statusId', label: this.$t('tables.status'), _style: 'width:15%'},
        // {key: 'toziKonande', label: this.$t('tables.driver'), _style: 'width:15%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
        // {key: 'select', label: this.$t('tables.select'),},

      ],


      details: [],

      status_form: 0,
      load_persons({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },

    }
  },
  mounted() {

    this.start_date = this.get_today();
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];

    this.get_all_data();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.person_id': function () {
      this.get_all_data();
    },
    'start_date': function () {
      this.get_all_data();
    },
    'end_date': function () {
      this.get_all_data();
    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      this.table_clicks_index = index
      if (this.table_clicks == 1 && this.table_clicks_index == index) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.table_clicks = 0

        this.goShowDocument(item)

      }

    },

    get_all_data() {

      this.get_lists_sell();


    },

    get_lists_sell() {

      var self = this;


      const formData = new FormData();

      var url = "GetFactorsByParams";
      formData.append("docType", 3);
      if (self.refer_person == null) {
        return null
      }
        formData.append("PersonId", self.refer_person);


      // formData.append("id", 3);

      formData.append("FirstDate", self.start_date);
      formData.append("SecondDate", self.end_date);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {

          self.items_sell = content_data.data.map((item, row_id) => {
            return {...item, row_id}

          });
          let total = 0
          let json_list = []
self.items_sell.forEach(function (val){
   total = 0;
   json_list=JSON.parse(val.cashInfo)
  json_list.forEach(function (pay){
    total+=pay.Amount
  })
  val.cashReceive = total
})

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });


    },

    Finalize(item) {
      var self = this;


      const formData = new FormData();

      var url = "AddFactorToFinal";

      formData.append("id", item.recId);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          item.statusId = 1;
        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    send_to_customer(item) {
      var self = this;


      const formData = new FormData();

      var url = "SendFactorToTelegramBoth";

      formData.append("id", item.recId);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          item.statusId = 1;
        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    goReturnDocument(item) {
      this.$router.push({
        path: '/dashboard/documents/return/' + item.recId + "/false",
        params: {passed_data: "salam hamidddd"}
      });
    },
    goShowDocument(item) {
window.open('/dashboard/documents/show/' + item.recId)
      // this.$router.push({path: '/dashboard/documents/show/' + item.recId});
    },
    goPrintDocument(item) {
      bus.$emit("print_confirm", item.recId);


    },
    AddRefer(item) {
      this.submit_refer = item.recId;
    },

    AddAllRefer() {
      this.submit_refer = -1;
      if (this.id_checkbox_items.length == 0) {
        console.log("validate form is false" + this.validate_errors);
        this.submit_refer = 0;

      }
    },

    insert_refer() {
      let self = this;

      if (this.submit_refer != -1) {


        this.id_checkbox_items = [];
      } else {
        if (this.id_checkbox_items.length == 0) {
          console.log("validate form is false" + this.validate_errors);
          self.submit_refer = 0;
          self.id_checkbox_items = [];

          return true;
        }

      }
      if (this.refer_person == null) {
        console.log("validate form is false" + this.validate_errors);

        return true;
      }
      let url;
      // if (this.status_form == 0) {
      url = "AddFactorRefer";
      // }
      if (this.submit_refer != -1) {
        const formData = new FormData();

        formData.append('PersonId', this.refer_person);

        formData.append('MasterFactorId', this.submit_refer);
        axios.post(url, formData, {}).then((res) => {



          self.submit_refer = 0;
          self.id_checkbox_items = [];

          self.refer_person = null;

          self.$root.modal_component.show_api_response_modals(res);
          self.get_all_data()
        })
            .catch(function (error) {

              console.log(error);
            });
      } else {
        self.id_checkbox_items.forEach((val) => {

          const formData = new FormData();

          formData.append('PersonId', this.refer_person);

          formData.append('MasterFactorId', val);
          axios.post(url, formData, {}).then((res) => {



          })
              .catch(function (error) {

                console.log(error);
              });
        });
        self.id_checkbox_items = [];
        self.submit_refer = 0;
        self.id_checkbox_items = [];

        self.refer_person = null;

        this.get_all_data()
      }


    },

  },

}

</script>
